import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_234: DocMigration = {
  maxSchemaVersion: "0.0.234",
  description: "Add lateral datum to all column placements",
  apply(json: any) {
    const { columns } = json;
    for (const columnId in columns) {
      const column = columns[columnId];
      for (const placementId in column.placements) {
        const placement = column.placements[placementId];
        if (placement.lateralDatum === undefined) {
          placement.lateralDatum = "ROOM_EDGE";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_234;
